module.exports = __webpack_public_path__ + "img/support.a1e9a38a.png";